import type { ReactElement } from 'react'
import { ImgGlyph } from './ImgGlyph'
import type { GlyphProps } from './shared'

// Base Koi silhouette uses the ★1 tier art. The active rendering for
// Ancient Koi goes through TIERED_GLYPHS (see tieredGlyphs.ts) which
// routes ★2/★3 to the richer tier images extracted from
// assets/ancient_koi_3tier.jpg.
export const Koi = ({ size = 110 }: GlyphProps): ReactElement => (
  <ImgGlyph src="/glyph-assets/koi-1.png" size={size} alt="koi" />
)
